import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";

import img1 from "../../assets/image/partner_1.png";
import img2 from "../../assets/image/partner_2.png";
import img3 from "../../assets/image/partner_3.png";
import img4 from "../../assets/image/partner_4.png";
import img5 from "../../assets/image/partner_5.png";

import { Pagination } from "swiper/modules";
import "swiper/css/pagination";

import video from "../../assets/image/course-video.mp4";
import { Fragment } from "react";

const Partners = () => {
  return (
    <div class="partners py-4">
      <div class="container">
        <div className="row">
          <div className="col">
            <div class="partners_slider_container">
              <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                breakpoints={{
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 5,
                  },
                }}
                loop={true}
                className="partners_slider"
              >
                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img1} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img4} alt="" />
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img2} alt="" />
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img3} alt="" />
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img4} alt="" />
                  </div>
                </SwiperSlide>
                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img1} alt="" />
                  </div>
                </SwiperSlide>

                <SwiperSlide className="item">
                  <div class="owl-item partner_item">
                    <img src={img5} alt="" />
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
